import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard, UserProfileResolver, CheckSessionGuard } from '@transfora/authentication';
import { NoPrivilegeComponent } from './no-privilege/no-privilege.component';

const routes: Routes = [
  {
  path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    resolve: { userProfile: UserProfileResolver },
    children: [
      {
        path: 'administration',
        canActivateChild: [CheckSessionGuard],
        loadChildren:
          () => import('./transfora-modules/administration.module').then(m => m.AdministrationModule),
        data: { preload: true, delay: true }
      },
      {
        path: 'manage-process',
        canActivateChild: [CheckSessionGuard],
        loadChildren:
          () => import('./transfora-modules/manage-process.module').then(m => m.ManageProcessModule),
        data: { preload: true, delay: true }
      },
      {
        path: 'processdesigner',
        canActivateChild: [CheckSessionGuard],
        loadChildren:
          () => import('./transfora-modules/process-designer.module').then(m => m.ProcessDesignerModule),
        data: { preload: true, delay: true }
      },
      {
        path: 'reportdesigner',
        canActivateChild: [CheckSessionGuard],
        loadChildren: () => import('./transfora-modules/reports-designer-app.module').then(m => m.ReportDesignerAppModule),
        data: { preload: true, delay: true }
      },
      {
        path: 'reports',
        canActivateChild: [CheckSessionGuard],
        loadChildren: () => import('./transfora-modules/reports.module').then(m => m.ReportsModule),
        data: { preload: true, delay: true }
      },
      {
        path: 'dashboard',
        canActivateChild: [CheckSessionGuard],
        loadChildren: () => import('./transfora-modules/dashboard.module').then(m => m.DashboardModule),
        data: { preload: true, delay: true }
      }
    ]
  },
  {
    path: 'noprivilege',
    component: NoPrivilegeComponent,
  },
  {
    path: 'home',
    redirectTo: '/manage-process'
  },
  {
    path: '**',
    redirectTo: 'manage-process'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
